import axios from 'axios';

import {catchAsync} from 'utils/catchAsync';

export const fetchNewsUnreadCount = (since) =>
    catchAsync(async () => {
        const params = since ? { since: new Date(since).toISOString() } : {};
        const { data } = await axios.get('news/count', { params });
        return typeof data.count === 'number' ? data.count : 0;
    });
